import { SpotBroadcastIcon } from '@tableau/icons/SpotBroadcastIcon';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { BrowserTitleService } from '~src/commonInfra/services/BrowserTitleService';
import { Location } from '~src/commonInfra/utils/Location';
import { ProjectDefinition } from '~src/projects/components/contentDefinitions/ProjectDefinition';
import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';
import { ExplorerEmptyStateProps } from '~src/spacesPlatform/components/Explorer/widgets/ExplorerEmpyState';
import { SpaceHeaderContent } from '~src/spacesPlatform/components/header/SpaceHeaderContent';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';

export interface BroadcastsSpaceStateProps {
    readonly urls: SpacesSiteUrls;
}

export interface BroadcastsSpaceOwnProps {
    readonly siteName: string;
}

export interface BroadcastsSpaceDispatchProps {
    readonly requestSpaceContents: () => void;
}

export type BroadcastsSpaceProps = BroadcastsSpaceStateProps
    & BroadcastsSpaceDispatchProps
    & BroadcastsSpaceOwnProps;


export class SiteBroadcastsSpace extends React.PureComponent<BroadcastsSpaceProps> {
    public componentDidMount() {
        this.props.requestSpaceContents();
        BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.broadcastsBrowserTitle() });
    }

    public render() {
        return (
            <div className={SpaceContainerStyles.SpaceContainer}>
                <div className={SpaceContainerStyles.MastheadArea}>
                    <SpaceHeaderContent headerText={Messages.broadcastsBrowserTitle()} />
                </div>
                <div className={SpaceContainerStyles.SubplaceArea}>
                    <ConnectedExplorer
                        supportedDisplayModes={ProjectDefinition.supportedDisplayModes}
                        emptyStateProps={this.emptyStateProps()}
                        toolbarProps={{
                            supportFilterPanel: false,
                            toolbarVisibility: 'enabled'
                        }}
                    />
                </div>
            </div>
        );
    }

    private emptyStateProps(): ExplorerEmptyStateProps {
        return {
            icon: SpotBroadcastIcon,
            primaryMessage: Messages.broadcastsEmptyStatePrimary(),
            secondaryMessage: Messages.broadcastsEmptyStateSecondary(),
            onActionButton: this.onNoContentAction,
            actionButtonMessage: Messages.emptyStateCallToAction(),
            dataTestId: BroadcastsSpaceTestIds.EMPTY_STATE,
        };
    }

    private onNoContentAction = (): void => {
        Location.instance.setUrl(this.props.urls.exploreUrl());
    };
}

export namespace BroadcastsSpaceTestIds {
  export const EMPTY_STATE = 'broadcasts-empty-state';
}